import axiosInstance from "axios";

// Base Axios call Promise
const baseAxios = (axiosInstance, isNestCall, url, method = "post", data = {}, sendErrorObj = false) => {
  return new Promise((resolve, reject) => {
    axiosInstance({ method, url, data })
      .then(({ data }) => resolve(data))
      .catch((err) => {
        if (!isNestCall) reject(err);
        else {
          const errors = err?.response?.data?.message;

          // Send error object
          if (sendErrorObj) {
            return reject({ ...err?.response?.data, status: err?.response?.status });
          }

          let printError = "";
          if (Array.isArray(errors)) {
            printError = errors.map((err, index) => <li key={index}>{err}</li>);
            printError = <ul className='m-0 p-0'>{printError}</ul>;
          } else {
            printError = errors;
          }
          reject(printError);
        }
      });
  });
};

// Axios call
export const axiosCallRest = (url, method = "post", data) => {
  const headers = {
    "Content-Type": "application/json",
    http_x_username: process.env.REACT_APP_HTTP_X_USERNAME,
    http_x_password: process.env.REACT_APP_HTTP_X_PASSWORD,
  };

  return new Promise((resolve, reject) => {
    axios[method](url, data, { headers })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err));
  });
};

// Axios call to Yii API
export const axiosCall = (url, method = "post", data = {}, headers = {}) => {
  // Create an Axios instance for Yii API
  const yiiAxiosInstance = axiosInstance.create({
    baseURL: process.env.REACT_APP_BASE_URL + "/api",
    withCredentials: true,
    headers: {
      Pragma: "no-cache",
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      ...headers,
    },
  });

  return baseAxios(yiiAxiosInstance, false, url, method, data);
};

// Axios call to Yii without API
export const axiosCallYii = (url, method = "post", data = {}, headers = {}) => {
  // Create an Axios instance for Yii API
  const yiiAxiosInstance = axiosInstance.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    withCredentials: true,
    headers: {
      Pragma: "no-cache",
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      ...headers,
    },
  });

  return baseAxios(yiiAxiosInstance, false, url, method, data);
};

// Axios call to NestJS API
export const axiosCallNest = (url, method = "post", data = {}, headers = {}, sendErrorObj = false) => {
  // Create an Axios instance for NestJS API
  const nestAxiosInstance = axiosInstance.create({
    baseURL: process.env.REACT_APP_NEST_BASE_URL,
    withCredentials: true,
    headers: {
      Pragma: "no-cache",
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      ...headers,
    },
  });

  return baseAxios(nestAxiosInstance, true, url, method, data, sendErrorObj);
};

// default axios
const axios = axiosInstance.create({
  withCredentials: true,
  headers: {
    Pragma: "no-cache",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
  },
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
});
axios.CancelToken = axiosInstance.CancelToken;

export default axios;
